import React, { useEffect, useState } from 'react';
import Alert from '../components/Alert/Alert';
import { generateDynamicLink } from '../core/utils/DynamicLink';
import QrCodeScreen from '../views/QrCode/QrCodeScreen';

const QrCodeContainer = () => {
  const [codes, setCodes] = useState([])

  const onChange = async (codes) => {
    const promises = []

    for (var i = 0; i < codes.length; i++) {
      const cod = codes[i]
      if (cod && Number.isInteger(cod)) {
        promises.push(
          generateDynamicLink(cod)
            .then(async item => ({ cod, data: await item.json() }))
        )
      }
    }

    const newCodes = await Promise.all(promises).catch(e => console.log({ e }))
    setCodes(newCodes)
  }

  const copyClipboard = async (shortLink) => {
    await navigator.clipboard.writeText(shortLink)
    const text = await navigator.clipboard.readText()
    if (text === shortLink) {
      Alert.success("Link copiado com sucesso!")
    }
  }

  return <QrCodeScreen codes={codes} onChange={onChange} copyClipboard={copyClipboard} />;
}

export default QrCodeContainer;